<script>
import ShareIcon from "@/components/common/Icons/Regular/ShareIcon.vue";
import { useClipboard } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "ShareButton",
  components: { ShareIcon },

  setup() {
    const currentInstance = localStorage.getItem("current_instance");
    const route = useRoute();

    const showTooltip = ref(false);
    const source = computed(() => window.location.origin + "/share/" + currentInstance + route.fullPath);

    const { text, copy, copied, isSupported } = useClipboard({ source });

    return {
      text,
      copy,
      copied,
      isSupported,
      showTooltip,
    };
  },
};
</script>

<template>
  <div class="h-full share-button flex select-none items-center justify-between p-4 focus:outline-none">
    <button
        class="flex select-none items-center justify-between gap-2 bg-gray-900 px-3 py-1 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-cyan-500"
        @click.stop="isSupported ? copy() : undefined"
        @mouseover="showTooltip = true"
        @mouseleave="showTooltip = false"
    >
      <share-icon class="h-5 text-gray-400 stroke-cyan-500" />
      <span class="text-gray-500 uppercase text-xs font-medium min-w-10 flex">
        {{ copied ? "Copied" : "Share" }}
      </span>
    </button>
  </div>
</template>

<style lang="scss">
.share-button svg {
  .fa-primary {
    fill: rgba(203, 213, 224, var(--text-opacity));
  }

  .fa-secondary {
    opacity: 1;
    fill: #718096;
  }
}

.min-w-10 {
  min-width: 3.2rem;
  justify-content: center;
}
</style>